export default __webpack_public_path__ + "static/media/AGC_2022_R4_QP_Class_3.6fad1a83.pdf";